import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Courier } from '../models/courier';
import { CourierFile } from '../models/courier-file';
import { CourierRepo } from '../repositories/courier.repo';
import { ToastPosition, ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class CourierService {

  constructor(
    private courierRepo: CourierRepo,
    private toastService: ToastService,
  ) { }

  getActiveCouriers(): Observable<Courier[]> {
    return this.courierRepo.getActiveCouriers();
  }

  passOrderToCourier(courierId: string, orderId: string): Observable<unknown> {
    return this.courierRepo.pushOrder(courierId, orderId)
      .pipe(tap(() => this.toastService.showSuccessToast("Order sucessvol aangeboden", ToastPosition.Top)));
  }

  getCourierFiles(): Observable<CourierFile[]> {
    return this.courierRepo.getCourierFiles();
  }
}
